"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookUpModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const jwt_1 = require("@nestjs/jwt");
const look_up_service_1 = require("./look-up.service");
const look_up_controller_1 = require("./look-up.controller");
const typeorm_1 = require("@nestjs/typeorm");
const look_up_entity_1 = require("../../../../service-lib/src/lib/entities/look-up.entity");
const look_up_repository_1 = require("./look-up.repository");
const auth_guard_1 = require("../../../../auth-service/src/guards/auth.guard");
const role_guard_1 = require("../../../../auth-service/src/guards/role.guard");
let LookUpModule = class LookUpModule {
};
exports.LookUpModule = LookUpModule;
exports.LookUpModule = LookUpModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [typeorm_1.TypeOrmModule.forFeature([look_up_entity_1.LookUp]), jwt_1.JwtModule],
        providers: [look_up_service_1.LookUpService, look_up_repository_1.LookUpRepository, auth_guard_1.AuthGuard, role_guard_1.RolesGuard],
        controllers: [look_up_controller_1.LookUpController],
        exports: [look_up_service_1.LookUpService, look_up_repository_1.LookUpRepository],
    })
], LookUpModule);
